<template>
  <div>
    <Button type="primary" @click="modal1 = true">新增</Button>
    <Button type="primary" @click="selmachine" style="margin-left: 10px;">刷新</Button>
    <Select
          v-model="machineType"
          placeholder="选择机器类型"
          style="width: 200px; margin-top: 10px"
          @on-change="handleCurrencyTypeChange"
        >
          <Option value="">全部</Option>
          <Option value="3">推币机</Option>
          <Option value="4">游戏机</Option>
      </Select>
    <Table :columns="columns10" :data="data9"> </Table>

    <Modal
      v-model="modal1"
      title="新增机器"
      width="1000"
      :loading="loading"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="机器类型">
            <RadioGroup v-model="jiqitype">
              <Radio label="3">推币机</Radio>
              <Radio label="4" checked>游戏机</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="小板号">
            <Input placeholder="请输入小板号" v-model="jiqihao"></Input>
          </FormItem>
          <FormItem label="房间名称">
            <Input placeholder="请输入房间名称" v-model="roomname"></Input>
          </FormItem>
          <FormItem label="备注名称">
            <Input placeholder="请输入备注名称" v-model="broomname"></Input>
          </FormItem>
          <FormItem label="房间副标题">
            <Input placeholder="请输入房间副标题" v-model="froomname"></Input>
          </FormItem>
          <FormItem label="房间等级">
            <Input placeholder="请输入房间等级" v-model="roomlv"></Input>
          </FormItem>
          <FormItem label="单价">
            <Input placeholder="请输入单价" v-model="danjia"></Input>
          </FormItem>
          <FormItem label="视频地址">
            <Input placeholder="请输入视频地址" v-model="videourl1"></Input>
          </FormItem>
          <FormItem label="奖励礼品id">
            <Input placeholder="请输入奖励礼品id" v-model="jiangli"></Input>
            <Button type="primary" size="small" @click="openGoodsSearchModal(false)" style="margin-left: 5px;">查询商品</Button>
          </FormItem>
          <FormItem label="输入进度条占比">
            <Input placeholder="请输奖励" v-model="progress"></Input>
          </FormItem>
          <FormItem label="识别小板号">
            <Input placeholder="请输入识别小板号" v-model="videomachineid"></Input>
          </FormItem>
          <FormItem label="jp1奖励">
            <Input placeholder="请输入jp1奖励" v-model="jpone" @input="validateNumber('jpone')"></Input>
          </FormItem>
          <FormItem label="jp2奖励">
            <Input placeholder="请输入jp2奖励" v-model="jptwo" @input="validateNumber('jptwo')"></Input>
          </FormItem>
          <FormItem label="jp3奖励">
            <Input placeholder="请输入jp3奖励" v-model="jpthree" @input="validateNumber('jpthree')"></Input>
          </FormItem>
          <FormItem label="jp4奖励">
            <Input placeholder="请输入jp4奖励" v-model="jpfour" @input="validateNumber('jpfour')"></Input>
          </FormItem>
          <FormItem label="jp5奖励">
            <Input placeholder="请输入jp5奖励" v-model="jpfive" @input="validateNumber('jpfive')"></Input>
          </FormItem>
          <FormItem label="all奖励">
            <Input placeholder="请输入all奖励" v-model="jpall" @input="validateNumber('jpall')"></Input>
          </FormItem>

          <FormItem label="排序">
            <Input placeholder="请输入排序" v-model="sort" @input="validateNumber('sort')"></Input>
          </FormItem>
          <FormItem label="中奖是否抽勋章">
            <RadioGroup v-model="ismedal">
              <Radio label="是">是</Radio>
              <Radio label="否" checked>否</Radio>
            </RadioGroup>
          </FormItem>
          <single-upload title="上传封面图" @update:image="updateimage1" />
          <single-upload title="上传规则图" @update:image="updateimage2" />
        </Form>
      </div>
    </Modal>
    <Modal
      v-model="editModal"
      title="编辑机器"
      width="1000"
      :loading="loading"
      @on-ok="updateMachine"
      @on-cancel="cancelEdit"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="机器类型">
            <RadioGroup v-model="editForm.jiqitype">
              <Radio label="3">推币机</Radio>
              <Radio label="4">游戏机</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="小板号">
            <Input placeholder="请输入小板号" v-model="editForm.jiqihao"></Input>
          </FormItem>
          <FormItem label="房间名称">
            <Input placeholder="请输入房间名称" v-model="editForm.roomname"></Input>
          </FormItem>
          <FormItem label="备注名称">
            <Input placeholder="请输入备注名称" v-model="editForm.broomname"></Input>
          </FormItem>
          <FormItem label="房间副标题">
            <Input placeholder="请输入房间副标题" v-model="editForm.froomname"></Input>
          </FormItem>
          <FormItem label="房间等级">
            <Input placeholder="请输入房间等级" v-model="editForm.roomlv"></Input>
          </FormItem>
          <FormItem label="单价">
            <Input placeholder="请输入单价" v-model="editForm.danjia"></Input>
          </FormItem>
          <FormItem label="视频地址">
            <Input placeholder="请输入视频地址" v-model="editForm.videourl1"></Input>
          </FormItem>
          <FormItem label="奖励礼品id">
            <Input placeholder="请输入奖励礼品id" v-model="editForm.jiangli"></Input>
            <Button type="primary" size="small" @click="openGoodsSearchModal(true)" style="margin-left: 5px;">查询商品</Button>
          </FormItem>
          <FormItem label="输入进度条占比">
            <Input placeholder="请输奖励" v-model="editForm.progress"></Input>
          </FormItem>
          <FormItem label="识别小板号">
            <Input placeholder="请输入识别小板号" v-model="editForm.videomachineid"></Input>
          </FormItem>
          <FormItem label="jp1奖励">
            <Input placeholder="请输入jp1奖励" v-model="editForm.jpone" @input="validateEditNumber('jpone')"></Input>
          </FormItem>
          <FormItem label="jp2奖励">
            <Input placeholder="请输入jp2奖励" v-model="editForm.jptwo" @input="validateEditNumber('jptwo')"></Input>
          </FormItem>
          <FormItem label="jp3奖励">
            <Input placeholder="请输入jp3奖励" v-model="editForm.jpthree" @input="validateEditNumber('jpthree')"></Input>
          </FormItem>
          <FormItem label="jp4奖励">
            <Input placeholder="请输入jp4奖励" v-model="editForm.jpfour" @input="validateEditNumber('jpfour')"></Input>
          </FormItem>
          <FormItem label="jp5奖励">
            <Input placeholder="请输入jp5奖励" v-model="editForm.jpfive" @input="validateEditNumber('jpfive')"></Input>
          </FormItem>
          <FormItem label="all奖励">
            <Input placeholder="请输入all奖励" v-model="editForm.jpall" @input="validateEditNumber('jpall')"></Input>
          </FormItem>

          <FormItem label="排序">
            <Input placeholder="请输入排序" v-model="editForm.sort" @input="validateEditNumber('sort')"></Input>
          </FormItem>
          <FormItem label="中jp奖励是否抽勋章">
            <RadioGroup v-model="editForm.ismedal">
              <Radio label="是">是</Radio>
              <Radio label="否" checked>否</Radio>
            </RadioGroup>
          </FormItem>
          <single-upload title="上传封面图" :old-url="editForm.fengmian" @update:image="updateEditImage1" />
          <single-upload title="上传规则图" :old-url="editForm.guize" @update:image="updateEditImage2" />
        </Form>
      </div>
    </Modal>
    <coinGameListModal
      :visible="modal3"
      :user_id="clickmachineid"
      @guanbimodal="guanbimodal"
    />

    <GoodsSearchModal
      :visible.sync="goodsSearchModal"
      :goodstypeOptions="goodstypeOptions"
      @select-goods="selectGoods"
    />
  </div>
</template>
<script>
import SingleUpload from "@/components/Upload/singleUpload";
import GoodsSearchModal from "@/components/GoodsSearchModal.vue";
import { formatOssUrl } from "@/utils";

import {
  cerCoinMachine,
  selCoinMachine,
  updateMachineStatus,
  updateCoinMachine,
} from "../../api/machine";
// 导入商品查询 API
import { cmsSelgoods } from "../../api/product";
import coinGameListModal from "./coinGameListModal.vue"; // 引入刚刚创建的封号组件

const OSS = require("ali-oss");
var ossClient = null;
export default {
  components: { SingleUpload, coinGameListModal, GoodsSearchModal },
  data() {
    return {
      machineNumber: "",
      machineType: "",
      modal3: false,
      jiqitype: "3",
      fengmian: "", //封面图
      guize: "", //规则图
      roomlv: "", //房间等级
      jiqihao: "", //机器号
      duankouhao: "", //端口号
      roomname: "", //房间名称
      broomname: "", // 备注名称
      froomname: "", // 房间副标题
      danjia: "", //单价
      jiangli: "", //奖励
      progress: "10", //询奖时间
      loading: true,
      modal1: false,
      xbid: "", //小板id
      xbsort: 1, //小板座位号
      clickmachineid: "",
      videourl1: "",
      videomachineid: "", // 识别小板号
      jpone: "0", // jp1奖励
      jptwo: "0", // jp2奖励
      jpthree: "0", // jp3奖励
      jpfour: "0", // jp4奖励
      jpfive: "0", // jp5奖励
      jpall: "0", // all奖励
      ismedal: "否", // 中奖是否抽勋章
      sort: "0", // 排序
      // 编辑相关数据
      editModal: false,
      editForm: {
        roomid: "", // 房间ID，用于更新时的标识
        jiqitype: "3",
        fengmian: "", //封面图
        guize: "", //规则图
        roomlv: "", //房间等级
        jiqihao: "", //机器号
        roomname: "", //房间名称
        broomname: "", // 备注名称
        froomname: "", // 房间副标题
        danjia: "", //单价
        jiangli: "", //奖励
        progress: "10", //询奖时间
        videourl1: "",
        videomachineid: "", // 识别小板号
        jpone: "0", // jp1奖励
        jptwo: "0", // jp2奖励
        jpthree: "0", // jp3奖励
        jpfour: "0", // jp4奖励
        jpfive: "0", // jp5奖励
        jpall: "0", // all奖励
        ismedal: "否", // 中奖是否抽勋章
        sort: 0, // 排序
      },
      columns10: [
        {
          title: "房间id",
          key: "roomid",
        },
        {
          title: "房间名称",
          key: "roomname",
        },
        {
          title: "备注名称",
          key: "broomname",
        },
        {
          title: "副标题",
          key: "froomname",
        },
        {
          title: "机器类型",
          key: "machinetype",
          render: (h, params) => {
            const status = params.row.machinetype;
            return h("span", status === 3 ? "推币机" : "游戏机");
          },
        },
        {
          title: "房间等级",
          key: "roomlv",
        },

        {
          title: "单价",
          key: "price",
        },
        {
          title: "封面图",

          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.roomimg)  ,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },

          // key: "image",
        },
        {
          title: "奖励礼品id",
          key: "reward",
        },
        {
          title: "奖励进度条",
          key: "progress",
        },
        // {
        //   title: "识别小板号",
        //   key: "videomachineid",
        // },
        {
          title: "jp1奖励",
          key: "jpone",
        },
        {
          title: "jp2奖励",
          key: "jptwo",
        },
        {
          title: "jp3奖励",
          key: "jpthree",
        },
        {
          title: "all奖励",
          key: "jpall",
        },
        {
          title: "机器状态",
          key: "status",
          render: (h, params) => {
            const status = params.row.status;
            return h(
              "span",
              status === 0 ? "关机" : status === 1 ? "开机" : "维护"
            );
          },
        },
        {
          title: "游戏状态",
          key: "type",
          minWidth: 90,
          render: (h, params) => h("span", String(params.row.type) === "1" ? "游戏中" : "空闲"),
        },
        {
          title: "玩家所属 App",
          key: "gameApp",
          minWidth: 140,
          render: (h, params) => {
            const row = params.row;
            if (String(row.type) !== "1") return h("span", "—");
            const colors = new Map([
              ["twservice", "#ed4014"],
              ["newservice", "#2d8cf0"],
              ["newclaw", "#19be6b"],
            ]);
            return h("span", {
              style: { color: colors.get(row.gameTag) || "#808695" },
            }, row.gameApp || "未知");
          },
        },
        {
          title: "操作",
          key: "action",
          width: 240,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.openEditModal(params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickmachineid = params.row.roomid.toString();
                      console.log("====" + this.clickmachineid);
                      this.modal3 = true;
                    },
                  },
                },
                "游戏记录"
              ),
              params.row.status === 0 || params.row.status === 2
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.machineNumber = params.row.machineid;

                          this.updateMachineStatus(1);
                        },
                      },
                    },
                    "开机"
                  )
                : null,
              params.row.status === 1 || params.row.status === 2
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.machineNumber = params.row.machineid;

                          this.updateMachineStatus(0);
                        },
                      },
                    },
                    "关机"
                  )
                : null,
              //娃娃机暂时去掉维护
              params.row.status === 1
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.machineNumber = params.row.machineid;
                          this.updateMachineStatus(2);
                        },
                      },
                    },
                    "维护"
                  )
                : null,
            ]);
          },
        },
      ],
      data9: [],
      // 商品查询相关数据（用于选择奖励礼品）
      goodstypeOptions: this.$goodsTypeOptions,
      goodsSearchModal: false,
      goodsSearchName: "",
      goodsSearchType: "",
      goodsData: [],
      goodsTotal: 0,
      goodsCurrent: 1,
      goodsColumns: [
        {
          title: "商品id",
          key: "id",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "封面图片",
          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.goodsimg)  ,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "商品分类",
          key: "goodstype",
        },
        {
          title: "商品数量",
          key: "goodsnum",
        }, {
          title: "分解币数",
          key: "coinnum",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.selectGoods(params.row);
                    },
                  },
                },
                "选择"
              ),
            ]);
          },
        },
      ],
      // 标记当前选择礼品是用于新增还是编辑
      selectRewardForEdit: false,
    };
  },
  mounted() {
    this.selmachine();
  },
  methods: {
    selmachine() {
      console.log("===");

      selCoinMachine({
        machinetype: this.machineType
      }).then((res) => {
        console.log("===" + JSON.stringify(res));

        this.data9 = res.data;
      });
    },
    
    handleCurrencyTypeChange() {
      this.selmachine();
    },
    updateimage1(value) {
      this.fengmian = value;
      console.log("updateimage1" + value);
    },
    updateimage2(value) {
      this.guize = value;
      console.log("updateimage2" + value);
    },
    // 编辑模态框相关方法
    updateEditImage1(value) {
      this.editForm.fengmian = value;
      console.log("updateEditImage1" + value);
    },
    updateEditImage2(value) {
      this.editForm.guize = value;
      console.log("updateEditImage2" + value);
    },
    openEditModal(row) {
      // 填充编辑表单数据
      this.editForm = {
        roomid: row.roomid,
        jiqitype: row.machinetype === 3 ? "3" : "4",
        fengmian: row.roomimg, // 设置封面图
        guize: row.rule, // 设置规则图
        roomlv: row.roomlv,
        jiqihao: row.machineid,
        roomname: row.roomname,
        broomname: row.broomname || "",
        froomname: row.froomname || "",
        danjia: row.price,
        jiangli: row.reward,
        progress: row.progress || "10",
        videourl1: row.videourl1 || "",
        videomachineid: row.videomachineid || "",
        jpone: row.jpone || "0",
        jptwo: row.jptwo || "0",
        jpthree: row.jpthree || "0",
        jpfour: row.jpfour || "0",
        jpfive: row.jpfive || "0",
        jpall: row.jpall || "0",
        ismedal: row.ismedal === 1 ? "是" : "否",
        sort: row.sort,
      };
      // 打开编辑模态框
      this.editModal = true;
    },
    updateMachine() {
      // 调用更新API
      updateCoinMachine({
        roomid: this.editForm.roomid,
        machineid: this.editForm.jiqihao,
        roomname: this.editForm.roomname,
        broomname: this.editForm.broomname,
        froomname: this.editForm.froomname || "",
        roomlv: this.editForm.roomlv,
        image: this.editForm.fengmian,
        rule: this.editForm.guize,
        price: this.editForm.danjia,
        reward: this.editForm.jiangli,
        progress: parseInt(this.editForm.progress),
        videourl1: this.editForm.videourl1,
        machinetype: this.editForm.jiqitype === "3" ? 3 : 4,
        videomachineid: this.editForm.videomachineid || "",
        jpone: this.editForm.jpone || "0",
        jptwo: this.editForm.jptwo || "0",
        jpthree: this.editForm.jpthree || "0",
        jpfour: this.editForm.jpfour || "0",
        jpfive: this.editForm.jpfive || "0",
        jpall: this.editForm.jpall || "0",
        sort: this.editForm.sort,
        ismedal: this.editForm.ismedal === "是" ? 1 : 0,
      })
        .then((res) => {
          this.$Message.success("更新成功");
          this.editModal = false;
          // 刷新列表
          this.selmachine();
        })
        .catch((err) => {
          this.$Message.error("更新失败");
        });
    },
    cancelEdit() {
      this.editModal = false;
      this.$Message.info("取消编辑");
    },
    ok() {
      cerCoinMachine({
        machineid: this.jiqihao,
        roomname: this.roomname,
        broomname: this.broomname,
        froomname: this.froomname || "",
        roomlv: this.roomlv,
        image: this.fengmian,
        rule: this.guize,
        price: this.danjia,
        reward: this.jiangli,
        progress: parseInt(this.progress),
        videourl1: this.videourl1,
        machinetype: this.jiqitype === "3" ? 3 : 4,
        sort: 0,
        videomachineid: this.videomachineid || "",
        jpone: this.jpone || "0",
        jptwo: this.jptwo || "0",
        jpthree: this.jpthree || "0",
        jpfour: this.jpfour || "0",
        jpfive: this.jpfive || "0",
        jpall: this.jpall || "0",
        sort: this.sort,
        ismedal: this.ismedal === "是" ? 1 : 0,
      })
        .then((res) => {
          this.modal1 = false;
          this.$Message.info("Clicked ok");
        })
        .catch((err) => {});
      //
    },
    cancel() {
      this.$Message.info("Clicked cancel");
    },
    updateMachineStatus(status) {
      updateMachineStatus({
        status: status,
        roomid: this.clickmachineid,
        machineNumber: this.machineNumber,
      }).then((res) => {
        this.selmachine();
      });
    },
    guanbimodal() {
      this.modal3 = false;
    },
    // 打开商品查询弹窗，flag=false 表示用于新增，true 表示用于编辑
    openGoodsSearchModal(isEdit) {
      this.selectRewardForEdit = !!isEdit;
      this.goodsSearchModal = true;
      this.goodsSearchName = "";
      this.goodsSearchType = "";
      this.goodsCurrent = 1;
      this.searchProducts();
    },
    // 关闭商品查询弹窗
    closeGoodsSearchModal() {
      this.goodsSearchModal = false;
    },
    // 查询商品列表
    searchProducts() {
      const params = {
        goodsname: this.goodsSearchName || undefined,
        goodstype: this.goodsSearchType || undefined,
        page: this.goodsCurrent,
      };

      cmsSelgoods(params)
        .then((response) => {
          this.goodsData = response.data.rows;
          this.goodsTotal = response.data.pagination.total;
          this.goodsCurrent = response.data.pagination.page;
        })
        .catch((error) => {
          this.$Message.error("获取商品列表失败");
          console.error(error);
        });
    },
    // 商品列表分页
    changeGoodsPage(page) {
      this.goodsCurrent = page;
      this.searchProducts();
    },
    // 选择商品：把商品 id 回填到奖励礼品 id 字段
    selectGoods(goods) {
      if (this.selectRewardForEdit) {
        this.editForm.jiangli = goods.id;
      } else {
        this.jiangli = goods.id;
      }
      this.goodsSearchModal = false;
      this.$Message.success("已选择商品：" + goods.goodsname);
    },
    // 验证数字输入
    validateNumber(field) {
      // 确保只能输入数字
      if (this[field] && !/^\d*$/.test(this[field])) {
        this[field] = this[field].replace(/[^\d]/g, '');
      }
    },
    // 验证编辑表单的数字输入
    validateEditNumber(field) {
      // 确保只能输入数字
      if (this.editForm[field] && !/^\d*$/.test(this.editForm[field])) {
        this.editForm[field] = this.editForm[field].replace(/[^\d]/g, '');
      }
    },
  },
};
</script>
